(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeTaxDialogController', TypeTaxDialogController);

    TypeTaxDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeTax'];

    function TypeTaxDialogController ($scope, $stateParams, $uibModalInstance, entity, TypeTax) {
        var vm = this;
        vm.typeTax = entity;
        vm.load = function(id) {
            TypeTax.get({id : id}, function(result) {
                vm.typeTax = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:typeTaxUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.typeTax.id !== null) {
                TypeTax.update(vm.typeTax, onSaveSuccess, onSaveError);
            } else {
                TypeTax.save(vm.typeTax, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
